/** A question the reader asked, as it shows in the conversation. */
const Question = ({ content }) => {
  return (
    <div className="flex justify-end">
      <div className="bg-muted text-foreground max-w-[85%] rounded-2xl rounded-br-md px-3.5 py-2 text-sm leading-6 whitespace-pre-wrap" data-testid="help-assistant-question">
        {content}
      </div>
    </div>
  );
};

export default Question;
